import React from 'react';
import { Hourglass, Position } from '../styles/LoadingElement';

const Loading = () => {
    return (
        <>
        <Position>
        <Hourglass/>
        </Position>
        </>
    )
}
export default Loading;